<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-documents"
        title="Bankverbindung"
        @save="saveBankAccountFormData">
        <template v-if="formContext.permissions.canCreateRetroactiveChangesNote === true" v-slot:after-icons>
            <csp-retroactive-changes-modal :record-id="recordId" title="Bankverbindung Kunde"/>
        </template>
        <b-row v-if="showChangelogButton">
            <div class="col d-flex justify-content-end">
                <csp-changelog-modal :changelog-url="changelogUrl"/>
            </div>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Kontoinhaber"
                property="depositor"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="IBAN"
                property="iban"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="BIC"
                property="bic"
                type="bankbicinput"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Bankname"
                property="bankName"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="PLZ der Bank"
                property="postalCode"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Ort der Bank"
                property="place"
                type="text"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CustomerBankAccount',
        mixins: [FormDataMixin],
        computed: {
            recordId() {
                return parseInt(this.$route.params.recordId);
            },
            changelogUrl() {
                return '/api/desktop/records/' + this.recordId + '/customer/bank-account/changelog';
            },
            showChangelogButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.showChangelog === true;
            },
        },
        methods: {
            saveBankAccountFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveCustomerBankAccount(this.recordId, postData)
                }
                this.saveFormData(formContext, saveFunction, null).then(() => {
                });
            },
        },
    }
</script>
